import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '../Components/Layout/Layout';
import './NotFound.css';

function NotFound() {
  const { t } = useTranslation();
  return (
    <Layout>
      <div className="notFoundWrap">
        <h1>{t('notFound.errorCode')}</h1>
        <p>{t('notFound.title')}</p>
        <Link to="/" className="notFoundLink">
          {t('notFound.goHome')}
        </Link>
      </div>
    </Layout>
  );
}

export default NotFound;
